import React from 'react';
import PropTypes from 'prop-types';

import BasicDataPod from '../BasicDataPod';
import Value from '../BasicDataPod/Value';
import Description from '../BasicDataPod/Description';
import Link from '../BasicDataPod/Link';
import './styles.css';

export default function TextDataPod({ content, ...rest }) {
  const { value, text, valueFooter, linkText, linkUrl, external } = content;

  return value ? (
    <BasicDataPod {...rest}>
      <div className="text-pod-value-container">
        <Value
          value={value.toLocaleString()}
          className={valueFooter ? 'no-margin' : ''}
        />
        <Description text={valueFooter} className="large-and-bolded" />
      </div>
      <Description text={text} />
      <Link linkText={linkText} linkUrl={linkUrl} external={external} />
    </BasicDataPod>
  ) : null;
}

TextDataPod.propTypes = {
  header: PropTypes.string,
  tooltip: PropTypes.string,
  footer: PropTypes.string,
  content: PropTypes.shape({
    value: PropTypes.string,
    text: PropTypes.string,
    valueFooter: PropTypes.string,
    linkText: PropTypes.string,
    linkUrl: PropTypes.string,
    external: PropTypes.bool,
  }),
};
